import React from 'react';
import ProfileShell from '../../components/forms/ProfileShell';
import { SectionHeader, Field, Input, Select, TextArea } from '../../components/forms/FormPrimitives';

const PART_STATUS = ['Active', 'Not active', 'Not sure'];
const MEDICARE_PRODUCTS = [
  'Medicare Advantage',
  'Medicare Supplement',
  'Part D (Prescription Drug)',
  'Not sure yet',
];

const MedicareProfile = () => {
  const sections = [
    {
      title: 'Medicare Status',
      render: (data, update) => (
        <div>
          <SectionHeader index={1} title="Medicare Status" subtitle="A few quick basics — share what you know." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Turning 65 soon?" testid="med-65">
              <Select value={data.turning_65_soon} onChange={(v) => update({ turning_65_soon: v })} options={['Yes', 'No']} />
            </Field>
            <Field label="Already on Medicare?" testid="med-on-medicare">
              <Select value={data.already_on_medicare} onChange={(v) => update({ already_on_medicare: v })} options={['Yes', 'No']} />
            </Field>
            <Field label="Date of Birth" testid="med-dob">
              <Input type="date" value={data.dob} onChange={(v) => update({ dob: v })} />
            </Field>
            <Field label="ZIP Code" testid="med-zip">
              <Input value={data.zip_code} onChange={(v) => update({ zip_code: v })} placeholder="75001" />
            </Field>
          </div>
        </div>
      ),
    },
    {
      title: 'Current Coverage',
      render: (data, update) => (
        <div>
          <SectionHeader index={2} title="Current Coverage" subtitle="If you have current coverage, share what you know." />
          <Field label="Describe current coverage" testid="med-current">
            <TextArea value={data.current_coverage} onChange={(v) => update({ current_coverage: v })} placeholder="e.g. employer plan, original Medicare, etc." />
          </Field>
          <div className="grid sm:grid-cols-2 gap-4 mt-4">
            <Field label="Medicare Part A" testid="med-part-a">
              <Select value={data.part_a_status} onChange={(v) => update({ part_a_status: v })} options={PART_STATUS} />
            </Field>
            <Field label="Medicare Part B" testid="med-part-b">
              <Select value={data.part_b_status} onChange={(v) => update({ part_b_status: v })} options={PART_STATUS} />
            </Field>
          </div>
        </div>
      ),
    },
    {
      title: 'Preferences',
      render: (data, update) => (
        <div>
          <SectionHeader index={3} title="Preferences" subtitle="Tell us what matters most so we can guide you." />
          <Field label="Prescription drug needs" testid="med-rx">
            <TextArea value={data.prescription_needs} onChange={(v) => update({ prescription_needs: v })} placeholder="List medications, or 'none' / 'not sure'" />
          </Field>
          <Field label="Preferred doctors" testid="med-doctors">
            <TextArea value={data.preferred_doctors} onChange={(v) => update({ preferred_doctors: v })} placeholder="Doctors you'd like to keep" />
          </Field>
          <Field label="Preferred pharmacies" testid="med-pharmacies">
            <Input value={data.preferred_pharmacies} onChange={(v) => update({ preferred_pharmacies: v })} placeholder="e.g. CVS, Walgreens" />
          </Field>
          <Field label="Interested in Medicare Advantage, Supplement, or Part D?" testid="med-interest">
            <Select value={data.product_interest} onChange={(v) => update({ product_interest: v })} options={MEDICARE_PRODUCTS} />
          </Field>
          <Field label="Anything else we should know?" testid="med-notes">
            <TextArea value={data.profile_notes} onChange={(v) => update({ profile_notes: v })} />
          </Field>
        </div>
      ),
    },
  ];

  return (
    <ProfileShell
      coverageType="medicare"
      sections={sections}
      intro="Medicare choices can feel confusing. Start with the basics, and we will help guide you through the next steps."
      personalTouchMessage="Medicare choices can feel confusing. Start with the basics — we'll help guide you through the next steps."
    />
  );
};

export default MedicareProfile;
